/* tslint:disable */
/* eslint-disable */
/**
 * Brandside Backend API
 * REST API бэкенда Brandside. Авторизация — Bearer-токен Laravel Passport (заголовок Authorization: Bearer token). Успешные ответы оборачиваются в конверт success_response — status: true, data: ...; ошибки — common_error_response — status: false, errors._common: сообщение.
 *
 * The version of the OpenAPI document: 1.0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime'
/**
 *
 * @export
 * @interface LoginRequest
 */
export interface LoginRequest {
  /**
   * OAuth grant type
   * @type {string}
   * @memberof LoginRequest
   */
  grant_type: LoginRequestGrantTypeEnum
  /**
   * ID OAuth-клиента
   * @type {string}
   * @memberof LoginRequest
   */
  client_id: string
  /**
   * Секрет OAuth-клиента
   * @type {string}
   * @memberof LoginRequest
   */
  client_secret: string
  /**
   * Электронная почта
   * @type {string}
   * @memberof LoginRequest
   */
  username?: string
  /**
   * Пароль
   * @type {string}
   * @memberof LoginRequest
   */
  password?: string
  /**
   *
   * @type {string}
   * @memberof LoginRequest
   */
  scope?: string
  /**
   * URI редиректа для authorization_code grant
   * @type {string}
   * @memberof LoginRequest
   */
  redirect_uri?: string
  /**
   * Авторизационный код для authorization_code grant
   * @type {string}
   * @memberof LoginRequest
   */
  code?: string
  /**
   * Идентификатор клиента из UTM-трекинга (seo)
   * @type {string}
   * @memberof LoginRequest
   */
  utmClientId?: string
  /**
   * Промокод из UTM-ссылки (seo)
   * @type {string}
   * @memberof LoginRequest
   */
  promocode?: string
}

/**
 * @export
 * @enum {string}
 */
export enum LoginRequestGrantTypeEnum {
  Password = 'password',
  AuthorizationCode = 'authorization_code',
}

/**
 * Check if a given object implements the LoginRequest interface.
 */
export function instanceOfLoginRequest(value: object): value is LoginRequest {
  if (!('grant_type' in value) || value['grant_type'] === undefined)
    return false
  if (!('client_id' in value) || value['client_id'] === undefined) return false
  if (!('client_secret' in value) || value['client_secret'] === undefined)
    return false
  return true
}

export function LoginRequestFromJSON(json: any): LoginRequest {
  return LoginRequestFromJSONTyped(json, false)
}

export function LoginRequestFromJSONTyped(
  json: any,
  ignoreDiscriminator: boolean
): LoginRequest {
  if (json == null) {
    return json
  }
  return {
    grant_type: json['grant_type'],
    client_id: json['client_id'],
    client_secret: json['client_secret'],
    username: json['username'] == null ? undefined : json['username'],
    password: json['password'] == null ? undefined : json['password'],
    scope: json['scope'] == null ? undefined : json['scope'],
    redirect_uri:
      json['redirect_uri'] == null ? undefined : json['redirect_uri'],
    code: json['code'] == null ? undefined : json['code'],
    utmClientId: json['utmClientId'] == null ? undefined : json['utmClientId'],
    promocode: json['promocode'] == null ? undefined : json['promocode'],
  }
}

export function LoginRequestToJSON(value?: LoginRequest | null): any {
  if (value == null) {
    return value
  }
  return {
    grant_type: value['grant_type'],
    client_id: value['client_id'],
    client_secret: value['client_secret'],
    username: value['username'],
    password: value['password'],
    scope: value['scope'],
    redirect_uri: value['redirect_uri'],
    code: value['code'],
    utmClientId: value['utmClientId'],
    promocode: value['promocode'],
  }
}
